var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6815 3.41818C14.6815 4.91939 13.4646 6.13636 11.9633 6.13636C10.4621 6.13636 9.24517 4.91939 9.24517 3.41818C9.24517 1.91697 10.4621 0.7 11.9633 0.7C13.4646 0.7 14.6815 1.91697 14.6815 3.41818Z",
    stroke: "#51CDA0",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9636 12.9714H11.9635L11.9631 12.9714L11.9601 12.9714L11.9468 12.9714L11.8927 12.971C11.8447 12.9706 11.7735 12.9698 11.6824 12.9682C11.5001 12.965 11.2387 12.9584 10.9246 12.9453C10.2946 12.9191 9.46087 12.8668 8.63228 12.7632C7.79317 12.6583 7.00394 12.506 6.44124 12.295C6.15765 12.1886 5.97878 12.0844 5.88198 11.9997C5.85101 11.9726 5.83508 11.9538 5.82743 11.9431C5.83847 11.2845 6.41425 10.4095 7.60837 9.64684C8.77187 8.90376 10.351 8.38961 11.9636 8.38961C13.5763 8.38961 15.1554 8.90376 16.3189 9.64684C17.513 10.4095 18.0888 11.2845 18.0998 11.9431C18.0922 11.9538 18.0763 11.9726 18.0453 11.9997C17.9485 12.0844 17.7696 12.1886 17.486 12.295C16.9233 12.506 16.1341 12.6583 15.295 12.7632C14.4664 12.8668 13.6326 12.9191 13.0027 12.9453C12.6886 12.9584 12.4272 12.965 12.2449 12.9682C12.1538 12.9698 12.0826 12.9706 12.0346 12.971L11.9804 12.9714L11.9672 12.9714L11.9642 12.9714L11.9637 12.9714H11.9637H11.9636ZM5.82121 11.9321C5.82147 11.9321 5.8226 11.934 5.82382 11.9377C5.82156 11.9339 5.82095 11.9321 5.82121 11.9321ZM18.1061 11.9321C18.1063 11.9321 18.1057 11.9339 18.1035 11.9377C18.1047 11.934 18.1058 11.9321 18.1061 11.9321ZM2.56364 5.82598H4.27273H6.13636V6.13507H4.27273H2.56364H0.7V5.82598H2.56364Z",
    stroke: "#51CDA0",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.5410ba983f8941060d4559ece33e5dd7.svg";
export { ForwardRef as ReactComponent };